export default __webpack_public_path__ + "static/media/card_track_co.7bb7ee76.png";